import moment from 'moment';

/**
 * Formatea un monto a moneda mexicana (MXN)
 * @param {number} amount 
 * @returns {string}
 */
export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
    }).format(amount);
};

/**
 * Formatea una fecha de ISO a legible (DD/MM/YYYY)
 * @param {string} dateString 
 * @returns {string}
 */
export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return moment(dateString).format('DD/MM/YYYY');
};

/**
 * Determina la clase CSS o color basado en el estado de la suscripción
 * @param {string} status 
 * @returns {string}
 */
export const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
        case 'activo':
        case 'active':
            return { color: '#0E9600', label: 'Activo' };
        case 'pausado':
        case 'paused':
            return { color: '#F1C901', label: 'Pausado' };
        case 'cancelado':
        case 'cancelled':
        case 'canceled':
            return { color: '#FF4444', label: 'Cancelado' };
        default:
            return { color: '#3E3E3E', label: status };
    }
};
